import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Sun9am = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00012 1.31598C8.3453 1.31598 8.62512 1.5958 8.62512 1.94098V3.05897C8.62512 3.40415 8.3453 3.68397 8.00012 3.68397C7.65494 3.68397 7.37512 3.40415 7.37512 3.05897V1.94098C7.37512 1.5958 7.65494 1.31598 8.00012 1.31598Z"
        fill="currentColor"
      />
      <path
        d="M8.00012 12.316C8.3453 12.316 8.62512 12.5958 8.62512 12.941V14.059C8.62512 14.4041 8.3453 14.684 8.00012 14.684C7.65494 14.684 7.37512 14.4041 7.37512 14.059V12.941C7.37512 12.5958 7.65494 12.316 8.00012 12.316Z"
        fill="currentColor"
      />
      <path
        d="M14.0591 8.625C14.4043 8.625 14.6841 8.34518 14.6841 8C14.6841 7.65482 14.4043 7.375 14.0591 7.375H12.9411C12.5959 7.375 12.3161 7.65482 12.3161 8C12.3161 8.34518 12.5959 8.625 12.9411 8.625H14.0591Z"
        fill="currentColor"
      />
      <path
        d="M3.68408 8C3.68408 8.34518 3.40426 8.625 3.05908 8.625H1.94109C1.59591 8.625 1.31609 8.34518 1.31609 8C1.31609 7.65482 1.59591 7.375 1.94109 7.375H3.05908C3.40426 7.375 3.68408 7.65482 3.68408 8Z"
        fill="currentColor"
      />
      <path
        d="M12.7264 4.15758C12.9704 3.9135 12.9704 3.51778 12.7264 3.2737C12.4823 3.02962 12.0866 3.02962 11.8425 3.2737L11.0519 4.06424C10.8079 4.30832 10.8079 4.70404 11.0519 4.94812C11.296 5.1922 11.6917 5.1922 11.9358 4.94812L12.7264 4.15758Z"
        fill="currentColor"
      />
      <path
        d="M4.94829 11.0519C5.19237 11.296 5.19237 11.6917 4.94829 11.9358L4.15775 12.7263C3.91367 12.9704 3.51794 12.9704 3.27387 12.7263C3.02979 12.4822 3.02979 12.0865 3.27387 11.8424L4.06441 11.0519C4.30848 10.8078 4.70421 10.8078 4.94829 11.0519Z"
        fill="currentColor"
      />
      <path
        d="M11.8424 12.7263C12.0865 12.9704 12.4822 12.9704 12.7263 12.7263C12.9703 12.4822 12.9703 12.0865 12.7263 11.8424L11.9357 11.0519C11.6917 10.8078 11.2959 10.8078 11.0518 11.0519C10.8078 11.296 10.8078 11.6917 11.0518 11.9358L11.8424 12.7263Z"
        fill="currentColor"
      />
      <path
        d="M4.94819 4.94817C4.70412 5.19225 4.30839 5.19225 4.06431 4.94817L3.27377 4.15763C3.02969 3.91355 3.02969 3.51782 3.27377 3.27374C3.51785 3.02967 3.91358 3.02967 4.15766 3.27374L4.94819 4.06428C5.19227 4.30836 5.19227 4.70409 4.94819 4.94817Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.511 10.8043C9.85348 11.4182 8.97066 11.794 8.00007 11.794C5.96766 11.794 4.32007 10.1464 4.32007 8.11399C4.32007 6.08158 5.96766 4.43399 8.00007 4.43399C8.97024 4.43399 9.85272 4.80942 10.5102 5.42291C10.5482 5.45792 10.5854 5.49416 10.6218 5.53159C11.2762 6.19592 11.6801 7.10779 11.6801 8.11399C11.6801 9.12061 11.2759 10.0328 10.621 10.6972C10.5851 10.7341 10.5484 10.7698 10.511 10.8043ZM5.57007 8.11399C5.57007 7.16028 6.11949 6.33489 6.91908 5.93707C6.51762 6.52144 6.2749 7.28217 6.2749 8.11399C6.2749 8.94581 6.51762 9.70655 6.91909 10.2909C6.11949 9.8931 5.57007 9.06771 5.57007 8.11399Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Sun9am;
